/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobPositionBusinessUnitExcludingIdJobPositionId } from './jobPositionBusinessUnitExcludingIdJobPositionId';
import { JobPositionCompetenceExcludingIdJobPositionId } from './jobPositionCompetenceExcludingIdJobPositionId';
import { NewJobPosition } from './newJobPosition';
import { WorkExperiencePositionExcludingIdJobPositionId } from './workExperiencePositionExcludingIdJobPositionId';


export interface JobPositionControllerCreateBulkRequestJobPositionsInner { 
    jobPosition?: NewJobPosition;
    workExperiencePositions?: Array<WorkExperiencePositionExcludingIdJobPositionId>;
    jobPositionCompetences?: Array<JobPositionCompetenceExcludingIdJobPositionId>;
    jobPositionBusinessUnits?: Array<JobPositionBusinessUnitExcludingIdJobPositionId>;
}

